import { Comment, NewCommentRequest } from "../../interfaces/ticket/Comment";

export async function getComments(ticketId: string, authToken: string): Promise<Comment[] | null> {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/tickets/${ticketId}/comments`, {
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch comments:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching comments:", error);
        return null;
    }
}

export async function addComment(ticketId: string, newComment: NewCommentRequest, authToken: string): Promise<Comment | null> {
    const formData = new FormData();
    formData.append('authorId', newComment.authorEmployeeId);
    formData.append('message', newComment.body);
    if (newComment.attachments) {
        newComment.attachments.forEach(file => {
            console.log('Adding File! ', file.name);
            formData.append('files', file);
        });
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/tickets/${ticketId}/comments`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
            body: formData,
        });

        if (!response.ok) {
            console.error("Failed to add comment:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error adding comment:", error);
        return null;
    }
}
